import styled from '@emotion/styled'
import React, { useState } from 'react'
import useRest from '../../hooks/useRest'
import { IFilter, IGenericObject, TableWithFields } from '@types'
import { Sunburst } from '../../components/Charts/Sunburst'
import { MainTable, StartUpFilters } from '@components'
import { Button, Card, Tooltip } from '@ss/meta-core-components'
import { generateQuery } from '@utils'
import { config } from '../../config'
import { StatisticsIcon } from '../../assets/icons/statisticsIcon'
import { AddIcon } from '../../assets/icons/addIcon'
import { RemoveIcon } from '../../assets/icons/removeIcon'

/**
 * Componente pagina NPL Analysis
 * @component
 */
export const NLP: React.FC = () => {
  // getFields per i parametri della tabella
  const { post: getAnalysis } = useRest<{ data: IGenericObject }>(
    '/plot_topics'
  )

  const [zoom, setZoom] = useState<string | null>(null)

  const [params, SetParams] = useState<TableWithFields>({
    filters: {},
    index: 'infocamere_nlp_startup',
    keys: [
      { value: 'codice_fiscale', type: 'categorical' },
      { value: 'denominazione', type: 'categorical' },
      { value: 'settore', type: 'categorical' },
      { value: 'labels_1', type: 'categorical' },
    ],
  })

  const getData =
    (topic: string, filters: IGenericObject<IFilter | null>) => () => {
      return getAnalysis({
        index: 'infocamere_nlp_topics',
        type: 'simple',
        settore: topic,
        query_data: generateQuery({ params: filters }),
      })
    }

  return (
    <StartUpFilters setParams={SetParams}>
      <MainTable
        params={params}
        selectedColumns={[]}
        optionalFilter={{ type: { value: 'simple', method: 'normal' } }}
      />
      <Container>
        {config.NLPTopic.map(({ label, value }, index) => (
          <Card
            titleComponent={
              <Title>
                <div style={{ placeSelf: 'center' }}>
                  <StatisticsIcon />
                </div>
                <Label>{label}</Label>
                <Tooltip
                  dataCy={`${value}`}
                  direction={'left'}
                  template={
                    <div data-cy={`zoom-${value}-tooltip`}>
                      {zoom === value ? 'Riduci' : 'Espandi'}
                    </div>
                  }
                >
                  <Button
                    dataCy={`${value}-zoom`}
                    onClick={() =>
                      setZoom((old) => (old === value ? null : value))
                    }
                  >
                    {zoom === value ? <RemoveIcon /> : <AddIcon />}
                  </Button>
                </Tooltip>
              </Title>
            }
            dataCy={'charts-container'}
            height={'100%'}
            width={'100%'}
          >
            <ChartContainer key={`${value}-${index}`} zoom={zoom === value}>
              <Sunburst
                dataCy={value}
                topic={value}
                getData={getData(value, params.filters)}
                dimensions={{
                  height: zoom === value ? '900px' : '500px',
                  width: zoom === value ? '830px' : '530px',
                }}
              />
            </ChartContainer>
          </Card>
        ))}
      </Container>
    </StartUpFilters>
  )
}
//region Style
const Container = styled.div<{ children: React.ReactNode[] }>`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
`
const Title = styled.div`
  display: grid;
  grid-template-columns: 45px auto 50px;
  width: 100%;
  gap: 30px;
`
const Label = styled.div`
  font-weight: 600;
  font-size: 25px;
  line-height: 25px;
  color: var(--text);
  text-transform: uppercase;
  place-self: center start;
`
const ChartContainer = styled.div<{ zoom: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 5px;
  height: max-content;
`

//endregion
